import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_LIST } from '@core/services/web-api/api-list';
import {map, mergeMap, takeUntil, tap} from 'rxjs/operators';
import {SessionModelResponse} from '@core/models/session-model-response.model';
import {Select, Store} from '@ngxs/store';
import {SetSession} from '@store/auth/auth.actions';
import {Observable} from 'rxjs';
import {GetUserEngageKey} from '@core/services/userengage/userengagekey';
import {CartService} from '@core/services/cart/cart.service';
import {GtmService} from '@core/services/gtm/gtm.service';
import { RegistrationData } from '@core/models/form-interfaces';
import {AbTestsService} from '@core/services/ab-tests/ab-tests.service';
import {AuthState} from '@store/auth/auth.state';
import {User} from '@core/models/user.model';
import {GonativeService} from '@core/services/gonative/gonative.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private httpClient: HttpClient,
    private store: Store,
    private window: Window,
    private cartService: CartService,
    private gtm: GtmService,
    private abTestsService: AbTestsService
  ) { }

  @Select(AuthState.user) user$: Observable<User>;

  public login(email_or_username: string, password: string, clearBasket: boolean = false) {
    this.user$.pipe().subscribe((user: User|null) => {
      if (user) {
        this.abTestsService.setSeed(user.ab_test_seed);
      }
    });

    return this.httpClient.post<SessionModelResponse>(API_LIST.login(clearBasket), {
      email_or_username,
      password,
    }).pipe(mergeMap((session: SessionModelResponse) => {

      // wait to process the SetSession event, but send further the session model

      return this.store.dispatch(new SetSession(session))
      .pipe(
        map(() => {
          this.cartService.refreshCart(true);

          if (GonativeService.isGonative()) {
            this.abTestsService.sendEvent('native-app-login');
          }

          setTimeout(() => {
            this.gtm.login();
          }, 1);

          return session;
        })
      );
    }));
  }

  public registerAndLogin(registrationFormData: RegistrationData, pageKey = 'regular', clearBasket = false): Observable<SessionModelResponse> {
    return this.register(registrationFormData, pageKey).pipe(mergeMap(() => {
      return this.login(registrationFormData.username, registrationFormData.plainPassword, clearBasket);
    }));
  }

  public register(registrationFormData: RegistrationData, pageKey = 'regular') {
    const reqParams = {
      pageKey: pageKey,
      userengageKey: GetUserEngageKey(''),
    };

    let queryParamsString = '';
    Object.keys(reqParams).forEach(param => {
      if (reqParams[param] !== null) {
        queryParamsString += queryParamsString === '' ? '?' : '&';
        queryParamsString += param + '=' + reqParams[param];
      }
    });

    const dataToMerge = {
      acquisition: this.window['gtmTrackedCampaignSource'] ? this.window['gtmTrackedCampaignSource'] : null,
      acquisitionCampaign: this.window['gtmTrackedCampaignName'] ? this.window['gtmTrackedCampaignName'] : null,
      status: 1,
    };

    const requestData = { ... dataToMerge, ...registrationFormData, abTestSeed: this.abTestsService.getInitiatedSeed() }

    return this.httpClient.post(API_LIST.registration() + queryParamsString, requestData);
  }
}
